<script setup lang="ts">
import type { HTMLAttributes } from "vue"
import { cva, type VariantProps } from "class-variance-authority"
import { Loader2Icon } from "lucide-vue-next"
import { cn } from "@/lib/utils"

const spinnerVariants = cva(
  "animate-spin",
  {
    variants: {
      size: {
        default: "size-4",
        sm: "size-3",
        lg: "size-8",
        xl: "size-12",
      },
    },
    defaultVariants: {
      size: "default",
    },
  },
)

type SpinnerVariants = VariantProps<typeof spinnerVariants>

const props = defineProps<{
  class?: HTMLAttributes["class"]
  size?: SpinnerVariants["size"]
}>()
</script>

<template>
  <Loader2Icon
    role="status"
    aria-label="Loading"
    :class="cn(spinnerVariants({ size }), props.class)"
  />
</template>
